import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import HomepageDesign1 from './components/HomepageDesign1';
import HomepageDesign2 from './components/HomepageDesign2';
import HomepageDesign3 from './components/HomepageDesign3';
import DeveloperPage from './components/DeveloperPage';
import FaqPage from './components/FaqPage';
import { initSentry } from './sentry';

initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
const pathname = window.location.pathname;

let RootComponent: React.FC;
if (pathname === '/1') {
  RootComponent = HomepageDesign1;
} else if (pathname === '/2') {
  RootComponent = HomepageDesign2;
} else if (pathname === '/3') {
  RootComponent = HomepageDesign3;
} else if (pathname === '/privacy') {
  RootComponent = PrivacyPolicy;
} else if (pathname === '/terms') {
  RootComponent = TermsOfService;
} else if (pathname === '/developers') {
  RootComponent = DeveloperPage;
} else if (pathname === '/faq') {
  RootComponent = FaqPage;
} else {
  RootComponent = App;
}

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="h-screen bg-black text-white flex items-center justify-center">Something went wrong. Please refresh and try again.</div>}>
      <RootComponent />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
